<template>
  <div class="argic-subject-form">
    <div class="argic-subject-form-top">
      <div class="argic-subject-form-top-left">
        <span class="vertical-line"></span>
        <span class="title-txt">{{ title }}</span>
      </div>
      <el-button size="medium" type="primary" v-if="buttonText" @click="add">
        <i class="el-icon-plus"></i>
        {{ buttonText }}
      </el-button>
    </div>
    <div class="argic-subject-form-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ArgicSubjectForm",
  props: {
    title: {
      type: String,
      default: "",
    },
    buttonText: {
      type: String,
      default: "",
    },
  },
  methods: {
    add() {
      this.$emit("add");
    },
  },
};
</script>

<style scoped lang="scss">
.argic-subject-form {
  &-top {
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;
    border-bottom: 1px solid #ededed;
    &-left {
      display: flex;
      align-items: center;
      .vertical-line {
        display: inline-block;
        width: 4px;
        height: 24px;
        background: #64c3a4;
        margin-right: 10px;
      }
      .title-txt {
        color: #64c3a4;
        font-family: Microsoft YaHei;
        font-size: 24px;
        font-weight: 700;
      }
    }
    .el-button--medium {
      padding: 8px 20px;
    }
  }
  &-content {
    margin: 20px 0;
    // background: #f7f9fb;
  }
}
</style>
